import { DislikeFilled } from "@ant-design/icons";

const DislikeIcon = () => {
  return <DislikeFilled style={{ color: "gray" }} />;
};

export default DislikeIcon;
